import React from "react"
import logo from "../../assets/images/Neo_Logo_A.svg"

const OverlayLoader = ({ show, label }) => {
    if (!show) return null
    return (
        <div
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(255, 255, 255, 0.85)",
                backdropFilter: "blur(2px)",
                zIndex: 100,
                borderRadius: "inherit",
            }}
        >
            <div className="animate-pulse">
                <img src={logo} alt="Neo Logo" height="40" className="mb-2" />
            </div>
            {label && <span className="mt-2 fw-semibold text-primary font-size-13">{label}</span>}
        </div>
    )
}

export default OverlayLoader
